import { render } from "./FilterAreas.vue?vue&type=template&id=091563e2"
import script from "./FilterAreas.vue?vue&type=script&lang=js"
export * from "./FilterAreas.vue?vue&type=script&lang=js"
script.render = render

export default script